import { Injectable } from '@angular/core';
import { AreaCodes } from './areaCodes';
import { Formatter } from 'app/services/models/custom-objects/formatter';

@Injectable({ providedIn: 'root' })
export class MaskService {

  constructor() { }

  public masks = {
    2: ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    3: ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    4: ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
  };

  public masksList = {
    2: new Formatter('(**) ** ****-****', /\(|\)|\s|\-/g),
    3: new Formatter('(**) *** ***-****', /\(|\)|\s|\-/g),
    4: new Formatter('(**) **** ***-***', /\(|\)|\s|\-/g)
  };



  maskAreacode(number) {
    return this.masks[number];
  }

  listMaskAreacode(number) {
    return this.masksList[number];
  }

  //Retorna máscara angular2-text-mask x código de área
  getPhoneMask(event) {
    if (event) {
      var phone = event.replace(/[^\d]+/gi, "");
      if (phone.length > 5) {
        var countryCode = phone.substring(0, 2);
        var areaCode = phone.substring(2, 6);
        var codes = AreaCodes.codes[countryCode];
        if (codes) {
          while (areaCode.length > 0) {
            if (codes[areaCode]) {
              return this.maskAreacode(areaCode.length);
            }
            areaCode = areaCode.substring(0, areaCode.length - 1);
          }
          return this.maskAreacode(3);
        }
      }
    }
    return this.maskAreacode(2);
  }

  //Retorna máscara Formatter x código de área
  getPhoneMaskList(event): Formatter {
    if (event) {
      var phone = event.replace(/[^\d]+/gi, "");
      if (phone.length > 5) {
        var countryCode = phone.substring(0, 2);
        var areaCode = phone.substring(2, 6);
        var codes = AreaCodes.codes[countryCode];
        if (codes) {
          while (areaCode.length > 0) {
            if (codes[areaCode]) {
              return this.listMaskAreacode(areaCode.length);
            }
            areaCode = areaCode.substring(0, areaCode.length - 1);
          }
          return this.listMaskAreacode(3);
        }
      }
    }
    return this.listMaskAreacode(2);
  }

}
